export default __webpack_public_path__ + "5d003baffadedbe5517650cddce7d363.png";